export default {
  fields: {
    online_shop_domain: 'Domeniu propriu pentru magazinul online',
    online_shop_domain_hint:
      'Un domeniu al restaurantului, de exemplu order.pizzeria-mario.com — doar pentru comenzi; un site web are nevoie de altul. După salvare, aici apar înregistrările de adăugat.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
